/*
 * author: wendux
 * email: 824783146@qq.com
 * source code: https://github.com/wendux/Ajax-hook
 **/
export { hook }from "./src/xhr-hook"
export { proxy } from "./src/xhr-proxy"




// WEBPACK FOOTER //
// ./index.js